import ActionTypes from "../constants/ActionTypes";

const initialState = {
  currentPattern: "",
  formData: {},
  documents: [],
  loading: false,
  error: null,
  lastRegistered: null,
};

const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_PATTERN:
      return {
        ...state,
        currentPattern: action.payload,
        error: null,
      };

    case ActionTypes.CLEAR_FORM_DATA:
      return {
        ...state,
        formData: {},
        currentPattern: "",
        error: null,
      };

    case ActionTypes.REGISTER_DOCUMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionTypes.REGISTER_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        lastRegistered: action.payload,
        error: null,
      };

    case ActionTypes.REGISTER_DOCUMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default documentReducer;
